import { MatDialogRef } from '@angular/material/dialog'

export const matDialogRefStub: Partial<MatDialogRef<never>> = {
  close() {
    return
  },
}
